import { useCallback } from 'react';
import { message } from 'antd';
import { IDetailedUser } from '../../interfaces';

export const useUserAddress = (data?: IDetailedUser) => {
  const copyAddress = useCallback(
    async (template: string) => {
      if (!data) return;
      const address = template.replace(/{{client.id}}/g, data.id.toString()).replace(/{{client.name}}/g, data.fullName);
      await navigator.clipboard.writeText(address);
      message.success('Ünvan kopyalandı.');
    },
    [data],
  );

  return [copyAddress] as const;
};
